import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "caass-group-import-student-data-table",
	templateUrl: "./group-import-student-data-table.component.html",
	styleUrls: ["./group-import-student-data-table.component.css"],
})
export class GroupImportStudentDataTableComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {
		this.MaxWidth = (window.innerWidth - 80).toString() + "px";

		this.UpdateData();
	}

	ngOnChanges() {
		this.UpdateData();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	MaxWidth: any = "800px";

	///////////////
	// Built-In
	///////////////

	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	@Input() lstPerson: any = [];

	//Filter lists
	lstStatusDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "StudentID", header: "Student ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "SchoolFullName", header: "School" },
		{ field: "GroupName", header: "Group" },
		{ field: "StatusDesc", header: "Status" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	UpdateData() {
		this.lstStatusDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.StatusDesc))).sort();
	}

	////////////////////////////////////////////
}
